import script from "./ShareDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDevice.vue?vue&type=script&setup=true&lang=js"

import "./ShareDevice.vue?vue&type=style&index=0&id=2dc8d806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc8d806"]])

export default __exports__